const checkChangePayMethodAllowed = (
  autoRenew: boolean,
  creditCardId: number,
  paypalId: string | null
) => {
  // if (!autoRenew) {
  //   return !creditCardId && (!paypalId || paypalId === "0");
  // }
  // return false;
  return !creditCardId && (!paypalId || paypalId === "0");
};

export default checkChangePayMethodAllowed;
